import { proxy, subscribe } from "valtio";
import { configStore } from "../state/CommonState";

import { Quotation, CargoDetails, ContainerDetails } from "../state/Types";
import QuoteCalcV2 from "../util/quote-calc-v2";

class Enquiryv2 {
        constructor() { this.initialize() }
    set(e) {
        Object.assign(this, new Enquiryv2())
        Object.assign(this, e)
    }
    copyFromContract(c) {
        this.initialize()
        console.log("###STUFFINGS", c.shipmentType.substr(0, 3))
        if (c.shipmentType.substr(0, 3) === 'FCL') {
            let stuffings = c.shipmentType.substr(5, c.shipmentType.length - 6).split('/')
            this.stuffingType = stuffings[0]
            this.destuffingType = stuffings[1]
            // this.carrierMBL = 'No'
            console.log("\n\n\n")
            console.log("###STUFFINGS", stuffings)
        }
        this.originType = 'Port'
        this.destinationType = 'Port'
        this.entity = c.entity
        this.gst = c.gst
        this.hazardous = c.hazardous
        this.quoteClass = c.quoteClass
        this.packingGroup = c.packingGroup
        this.unnumber = c.unnumber
        // this.carrierMBL = c.carrierMBL
        this.nonStackable = c.nonStackable
        this.temperatureControlled = c.temperatureControlled
        this.temperature = c.temperature
        this.cargoValue = c.cargoValue
        this.minTemperature = c.minTemperature
        this.maxTemperature = c.maxTemperature
        this.shipmentType = c.shipmentType
        this.shipmentScope = c.shipmentScope
        this.enqRoute.origin = c.origin
        this.enqRoute.destination = c.destination
        this.enqRoute.cargoReadinessDate = c.cargoReadinessDate
        this.enqRoute.customerReferenceNum = c.customerReferenceNum
        this.cargoDetails = [new Cargov2()]
        if (c.cargoList.length > 0) this.cargoDetails = []
        c.cargoList.map(e => {
            let a = new Cargov2()
            a.packageType = e.packageType
            a.quantity = e.numPackages
            a.weight.value = e.wtPerPackage
            a.volume.value = e.volPerPackage
            a.totalWeight.value = e.totalWeight
            a.totalVolume.value = e.totalVolume
            a.chargeableWeight.value = e.chargeableWeight
            a.dimensions.height = e.height
            a.dimensions.width = e.width
            a.dimensions.length = e.length
            this.cargoDetails.push(a)
        })
        this.containerDetails = [new Containerv2()]
        if (c.containerList.length > 0) this.containerDetails = []
        c.containerList.map(e => {
            let a = { ...e }
            this.containerDetails.push(a)
        })
        console.log('OH!', JSON.stringify(c.containerList), JSON.stringify(this.containerDetails))
        this.containerDetails = [...this.containerDetails]
        this.tsClientviewOn = c.tsClientviewOn
    }
    initialize() {
        this.createdBy = ''
        this.entityId = '' // will contain the entityName with state
        // this.gst = '' // this will contain the gst
        this.shipmentType = ''
        this.shipmentScope = ''
        this.originType = 'Port'
        this.destinationType = 'Port'
        this.hazardous = 'No'
        this.quoteClass = ''
        this.packingGroup = ''
        this.unnumber = ''
        this.nonStackable = 'No'
        this.temperatureControlled = 'No'
        this.temperature = ""
        this.cargoValue = 0
        this.minTemperature = ''
        this.maxTemperature = ''
        this.stuffingType = 'Factory'
        this.destuffingType = 'Factory'
        // this.carrierMBL = 'No'
        this.enquiryNum = ''
        this.status = 'ENQUIRY'
        this.enqRoute = new EnqRoutev2()
        this.cargoDetails = null
        this.cargoDetails = [new Cargov2()]
        this.cargoDimensionUnit = 'Cms'
        this.containerDetails = [new Containerv2()]
        this.vehicleDetails = new VehicleTypesv2()
        this.hasToShowDummySchedule = false
    }
    addCargoLine() {
        this.cargoDetails.push(new Cargov2())
    }
    mergeIntoContract(rec) {
        let c = { ...rec }
        let enqCargoList = this.cargoDetails
        c.cargoList = []

        for (let i = 0; i < enqCargoList.length; i++) {
            let e = new CargoDetails()
            let a = enqCargoList[i]
            e.packageType = a.packageType
            e.numPackages = a.quantity
            e.wtPerPackage = a.weight.value
            e.volPerPackage = a.volume.value
            e.totalWeight = a.totalWeight.value
            e.totalVolume = a.totalVolume.value
            e.chargeableWeight = a.chargeableWeight.value
            e.height = a.dimensions.height
            e.width = a.dimensions.width
            e.length = a.dimensions.length
            c.cargoList.push(e)
        }
        c.containerList = []
        for (let i = 0; i < this.containerDetails.length; i++) {
            let e = new ContainerDetails()
            let a = this.containerDetails[i]
            e.containerType = a.containerType
            e.numContainers = a.numContainers
            e.wtPerContainer = a.wtPerContainer
            c.containerList.push(e)
        }

        let data = new QuoteCalcV2(c).recalc()
        return data
    }
}

class Cargov2 {
    constructor() {
        this.initialize()
    }
    initialize() {
        this.packageType = ''
        this.quantity = ''
        this.weight = {
            value: 0.0,
            unit: 'Kgs'
        }
        this.chargeableWeight = {
            value: 0.0,
            unit: 'Kgs'
        }
        this.volume = {
            value: 0.0,
            unit: 'CBM'
        }
        this.totalWeight = {
            value: 0.0,
            unit: 'Kgs'
        }
        this.totalVolume = {
            value: 0.0,
            unit: 'CBM'
        }
        this.dimensions = {
            length: 0.0,
            width: 0.0,
            height: 0.0,
            unit: 'Cms'
        }
    }
}
class VehicleTypesv2 {
    constructor() {
        this.initialize()
    }
    initialize() {
        this.fields = {
            'tataAce': 'Tata Ace',
            'bolero': 'Bolero',
            'trailer14': '14 Foot Trailer',
            'tata407': 'Tata 407',
            'trailer20': '20 Foot Trailer',
            'trailer24': '24 Foot Trailer',
            'sxl32': '32 Foot SXL',
            'mxl32': '32 Foot MXL',
        }
        this.fieldkeys = Object.keys(this.fields)
        for (let i = 0; i < this.fieldkeys.length; i++) {
            let key = this.fieldkeys[i]
            this[key] = 0
        }
    }
}
class Containerv2 {
    constructor() {
        this.initialize()
    }
    initialize() {
        this.containerType = ''
        this.numContainers = 0
        this.wtPerContainer = 0
        this.unit = 'Kgs'
    }
}
class EnqRoutev2 {
    set(e) {
        Object.assign(this, new EnqRoutev2())
        Object.assign(this, e)
    }
    initialize() {
        this.origin = ''
        this.destination = ''
        this.cargoReadinessDate = ''
        this.customerReferenceNum = ''
    }
    constructor() {
        this.initialize()
    }
}

let routeFlagv2 = proxy({
    originRouteFlag: 'No',
    destinationFlag: 'No'
})

let enquiryStorev2 = proxy({
    list: [],
    current: new Enquiryv2(),
    cargoDetailsChanges: 0,
    initialize: () => {
        enquiryStorev2.current = new Enquiryv2()
        enquiryStorev2.cargoDetailsChanges = 0
    },
    initializeWithConract: (c) => {
        enquiryStorev2.current = new Enquiryv2()
        enquiryStorev2.current.copyFromContract(c)
    },
    currentCargoTableKey: '',
    currentEnquiryListComponent: 'list' // list, view
})
const unsubscribe = subscribe(enquiryStorev2.current.cargoDetails, () => {
    console.log('CARGODETAILS CHANGED=', enquiryStorev2.current.cargoDetails[0].volume.value)
    configStore.displaySchedules = false
})
const unsubscribe1 = subscribe(enquiryStorev2.current.containerDetails, () => {
    console.log('CONTAINERDETAILS CHANGED=', enquiryStorev2.current.containerDetails[0].containerType)
    configStore.displaySchedules = false
})
export {
    EnqRoutev2, Enquiryv2, enquiryStorev2, Cargov2, Containerv2, VehicleTypesv2,routeFlagv2
}